import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DatavirtualizationService {

  accessToken: string = "";
  schemaUrl: string = "https://qa-api.digitalvault.cloud/apollo/v1.0/schemaregistry"; //"https://uat-api.digitalvault.cloud/apollo/v1.0/schemaregistry";
  entityUrl: string = "https://qa-api.digitalvault.cloud/apollo/v1.0/graph" //"https://uat-api.digitalvault.cloud/apollo/v1.0/graph/entities";


  allschemaURL = this.schemaUrl + "/schema-validation/entitytypes?pageNo=1&pageSize=100";
  allRelationshipTypesURL = this.schemaUrl + "/schema-validation/relationshiptypes";
  allEntitiesByEntityTypeURL = this.entityUrl + "/entities/";
  allRelationshipsForEntitiesURL = this.entityUrl + "/relationships"


  entityInstances: Array<any> = [];


  constructor(private http: Http) { }

  getHeaders(headers: { key: string, value: string }[] = null): Headers {

    var headerCollection = new Headers({ 'Authorization': 'Bearer ' + this.accessToken, "Content-Type": "application/json" });

    if (headers) {
      headers.forEach(header => {
        headerCollection.append(header.key, header.value);
      });
    }
    return headerCollection;
  }

  getToken(): Observable<any> {
    if (!this.accessToken) {
      var headerCollection: Headers = new Headers({ 'Authorization': 'Basic aW5mb3N5cy5kZXYucm86OGtHOFpteVNOVGZyUEVlVg==', "Content-Type": "application/x-www-form-urlencoded" });

      //const body = 'grant_type=password&username=infosys.user1&password=happy14&scope=entity_read entity_write read write';
      var bodyParam = new HttpParams().set("grant_type", "password")
        .set("username", "infosys.user1")
        .set("password", "happy14")
        .set("scope", "entity_read entity_write read write")
      return this.http.post("https://uat-api.digitalvault.cloud/Identity/ims/connect/token", bodyParam.toString(), { headers: headerCollection })
        .map((response) => {
          this.accessToken = response.json().access_token;
          return response.json() || {};

        }).catch((err: Response) => {
          console.log(err);
          return Observable.throw(err);
        });
    }
  }

  getAllSchemas(token): Observable<any> {

    var headerCollection = new Headers({ 'Authorization': 'Bearer ' + token, "Content-Type": "application/json" });

    return this.http.get(this.allschemaURL, { headers: headerCollection }).map(res => {
      // console.log('Schemas in Service Layer' + res.json());
      return res.json() || {}

    }).catch((err: Response) => {
      this.raiseUnAuthorizedTokenError(err);
      return Observable.throw("something went wrong");
    });
  }

  getAllRelationshipTypes(token): Observable<any> {
    var headerCollection = new Headers({ 'Authorization': 'Bearer ' + token, "Content-Type": "application/json" });

    return this.http.get(this.allRelationshipTypesURL, { headers: headerCollection }).map(res => {
      // console.log('Relationship Types in Service Layer' + res.json());
      return res.json() || {}
    }).catch((err: Response) => {
      this.raiseUnAuthorizedTokenError(err);
      return Observable.throw("something went wrong");
    });

  }

  getAllEntitiesByEntityType(token, entityType, ercollectionId): Observable<any> {
    var headerCollection = new Headers({
      'Authorization': 'Bearer ' + token, "Content-Type": "application/json"
      , 'ercollectionid': ercollectionId
    });

    return this.http.get(this.allEntitiesByEntityTypeURL + entityType, { headers: headerCollection }).map(res => {
      console.log('Entities in Service Layer' + res.json());
      return res.json() || {}
    }).catch((err: Response) => {
      this.raiseUnAuthorizedTokenError(err);
      return Observable.throw("something went wrong");
    });
  }

  getAllRelationshipsForEntities(token, ercollectionId): Observable<any> {
    var headerCollection = new Headers({
      'Authorization': 'Bearer ' + token, "Content-Type": "application/json"
      , 'ercollectionid': ercollectionId
    });

    return this.http.get(this.allRelationshipsForEntitiesURL, { headers: headerCollection }).map(res => {
      console.log('Relationships in Service Layer' + res.json());
      return res.json() || {}
    }).catch((err: Response) => {
      this.raiseUnAuthorizedTokenError(err);
      return Observable.throw("something went wrong");
    });

  }

  getAllRelationshipsByEntityId(entityId, token, ercollectionid): Array<any> {

    let relationshipsByEntityId: Array<any> = [];

    this.getAllRelationshipsForEntities(token, ercollectionid).subscribe(res => {
      
    }, error => {
      this.raiseUnAuthorizedTokenError(error);
    })

    return relationshipsByEntityId;

  }

  postEnitityInstance(token, entity, ercollectionId, isAsync): Observable<any> {

    var headerCollection = new Headers({
      'Authorization': 'Bearer ' + token, "Content-Type": "application/json",
      'ercollectionid': ercollectionId, 'async': isAsync
    });

    return this.http.post(this.entityUrl + '/api/v3.0/entities', JSON.stringify(entity), { headers: headerCollection })
      .map((response) => {
        this.accessToken = response.json().access_token;
        return response.json() || {};

      }).catch((err: Response) => {
        console.log(err);
        return Observable.throw(err);
      });

  }

  postEntityRelationships(token, entityRelationship, ercollectionId, isAsync): Observable<any> {
    var headerCollection = new Headers({
      'Authorization': 'Bearer ' + token, "Content-Type": "application/json",
      'ercollectionid': ercollectionId, 'async': isAsync
    });

    return this.http.post(this.entityUrl + '/api/v3.0/relationships', JSON.stringify(entityRelationship), { headers: headerCollection })
      .map((response) => {
        this.accessToken = response.json().access_token;
        return response.json() || {};

      }).catch((err: Response) => {
        console.log(err);
        return Observable.throw(err);
      });

  }

  raiseUnAuthorizedTokenError(response: Response) {
    if (response.status === 401) {
    }
  }

  getAllSchemasTestData(): any {
    var schemas: any = {};
    schemas = [
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "description": "Schema for EntityType facdemo:building",
        "title": "facdemo:building",
        "type": "object",
        "ercollectionid": "facdemo",
        "required": [
          "id",
          "name",
          "type"
        ],
        "schemaType": "facdemo:building",
        "state": "new", "properties": {
          "id": {
            "description": "building unique identifier",
            "type": "string"
          },
          "name": {
            "description": "building name",
            "type": "string"
          },
          "type": {
            "description": "building type",
            "type": "string"
          },
          "long": {
            "description": "building longitude",
            "type": "string"
          },
          "lat": {
            "description": "building latitude",
            "type": "string"
          },
          "image_uri": {
            "description": "image Uri",
            "type": "string"
          }
        }
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "description": "Schema for EntityType facdemo:cardholder",
        "title": "facdemo:cardholder",
        "type": "object",
        "ercollectionid": "facdemo",
        "required": [
          "id",
          "cardNumber",
          "firstName",
          "lastName",
          "department",
          "position",
          "company"
        ],
        "schemaType": "facdemo:cardholder",
        "state": "new",
        "properties": {
          "id": {
            "description": "cardholder unique identifier",
            "type": "string"
          },
          "cardNumber": {
            "description": "card number",
            "type": "string"
          },
          "firstName": {
            "description": "first name",
            "type": "string"
          },
          "lastName": {
            "description": "last name",
            "type": "string"
          },
          "department": {
            "description": "department",
            "type": "string"
          },
          "position": {
            "description": "position",
            "type": "string"
          },
          "company": {
            "description": "company",
            "type": "string"
          },
          "countrycode": {
            "description": "Personal Phone Number",
            "type": "string"
          },
          "areacode": {
            "description": "Work Phone Number",
            "type": "string"
          },
          "personalPhoneNumber": {
            "description": "Personal Email Id",
            "type": "string"
          },
          "personalemailId": {
            "description": "Work Email Id",
            "type": "string"
          },
          "isActive": {
            "description": "is Active",
            "type": "string"
          },
          "sourceType": {
            "description": "Source Type",
            "type": "string"
          }
        }
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "description": "Schema for EntityType facdemo:device",
        "title": "facdemo:device",
        "type": "object",
        "ercollectionid": "facdemo",
        "required": [
          "id",
          "name",
          "devicetype",
          "devicemodelnumber",
          "deviceserialnumber"
        ],
        "schemaType": "facdemo:device",
        "state": "new",
        "properties": {
          "id": {
            "description": "device unique identifier",
            "type": "string"
          },
          "devicemodelnumber": {
            "description": "device model number",
            "type": "string"
          },
          "deviceserialnumber": {
            "description": "device serial number",
            "type": "string"
          },
          "name": {
            "description": "device name",
            "type": "string"
          },
          "devicetype": {
            "description": "device type",
            "type": "string"
          },
          "lastservicetime": {
            "description": "device last service time",
            "type": "string"
          },
          "installationtime": {
            "description": "device installation time",
            "type": "string"
          },
          "softwareupgradetime": {
            "description": "device software upgrade time",
            "type": "string"
          },
          "devicetypedesc": {
            "description": "device type description",
            "type": "string"
          },
          "deviceparentpanel": {
            "description": "device parent panel",
            "type": "string"
          },
          "devicehealthupdatetime": {
            "description": "device health update time",
            "type": "string"
          },
          "devicehealthid": {
            "description": "device health id",
            "type": "string"
          },
          "devicehealthstring": {
            "description": "device health string",
            "type": "string"
          }
        }
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "description": "Schema for EntityType facdemo:manager",
        "title": "facdemo:manager",
        "type": "object",
        "ercollectionid": "facdemo",
        "required": [
          "id",
          "firstName",
          "lastName",
          "department",
          "position",
          "company"
        ],
        "schemaType": "facdemo:manager",
        "state": "new",
        "properties": {
          "id": {
            "description": "manager unique identifier",
            "type": "string"
          },
          "firstName": {
            "description": "first name",
            "type": "string"
          },
          "lastName": {
            "description": "last name",
            "type": "string"
          },
          "department": {
            "description": "department",
            "type": "string"
          },
          "position": {
            "description": "position",
            "type": "string"
          },
          "company": {
            "description": "company",
            "type": "string"
          },
          "countrycode": {
            "description": "Personal Phone Number",
            "type": "string"
          },
          "areacode": {
            "description": "Work Phone Number",
            "type": "string"
          },
          "personalPhoneNumber": {
            "description": "Personal Email Id",
            "type": "string"
          },
          "personalemailId": {
            "description": "Work Email Id",
            "type": "string"
          },
          "isActive": {
            "description": "is Active",
            "type": "string"
          },
          "sourceType": {
            "description": "Source Type",
            "type": "string"
          }
        }
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "description": "Schema for EntityType facdemo:security",
        "title": "facdemo:security",
        "type": "object",
        "ercollectionid": "facdemo",
        "required": [
          "id",
          "firstName",
          "lastName",
          "department",
          "position",
          "company"
        ],
        "schemaType": "facdemo:security",
        "state": "new",
        "properties": {
          "id": {
            "description": "security unique identifier",
            "type": "string"
          },
          "firstName": {
            "description": "first name",
            "type": "string"
          },
          "lastName": {
            "description": "last name",
            "type": "string"
          },
          "department": {
            "description": "department",
            "type": "string"
          },
          "position": {
            "description": "position",
            "type": "string"
          },
          "company": {
            "description": "company",
            "type": "string"
          },
          "countrycode": {
            "description": "Personal Phone Number",
            "type": "string"
          },
          "areacode": {
            "description": "Work Phone Number",
            "type": "string"
          },
          "personalPhoneNumber": {
            "description": "Personal Email Id",
            "type": "string"
          },
          "personalemailId": {
            "description": "Work Email Id",
            "type": "string"
          },
          "isActive": {
            "description": "is Active",
            "type": "string"
          },
          "sourceType": {
            "description": "Source Type",
            "type": "string"
          }
        }
      }
    ]
    return schemas;
  }

  getAllEntityRelationshipsTestData(): Array<any> {
    var relationshipTypes: any = {};
    relationshipTypes = [
      {
        "id": "27eb950c-7933-44fd-8329-dd1dfd416b81",
        "sourceentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "destinationentityid": "Device:Frictionless1",
        "ercollectionid": "facdemo",
        "relationshipname": "GooglePlex contains Middle Door",
        "relationshiptype": "contains"
      },
      {
        "id": "f2bde4ba9a3-a55e-4aa5b979-1ce5-4c89f",
        "sourceentityid": "9149d363-2cf0-4906-846d-be8bc4393178",
        "destinationentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "ercollectionid": "facdemo",
        "relationshipname": "Todd Horan guards GooglePlex",
        "relationshiptype": "guards"
      },
      {
        "id": "3d95598e-c3d2-4258-aafb-8741641232c9",
        "sourceentityid": "138a286f-2904-4911-a25b-06d840e86191",
        "destinationentityid": "86b5239a-8124-4cfe-a0cb-f3e63f9fb8bf",
        "ercollectionid": "facdemo",
        "relationshipname": "Mary Smith guards Yahoo!",
        "relationshiptype": "guards"
      },
      {
        "id": "e0262995-471b-47e3-89a2-c3dccf73ef12",
        "sourceentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "destinationentityid": "9149d363-2cf0-4906-846d-be8bc4393178",
        "ercollectionid": "facdemo",
        "relationshipname": "GooglePlex isGuardedBy Todd Horan",
        "relationshiptype": "isGuardedBy"
      },
      {
        "id": "ad94b382-801e-4a47-90ad-8316a0010aaa",
        "sourceentityid": "86b5239a-8124-4cfe-a0cb-f3e63f9fb8bf",
        "destinationentityid": "138a286f-2904-4911-a25b-06d840e86191",
        "ercollectionid": "facdemo",
        "relationshipname": "Yahoo! isGuardedBy Mary Smith",
        "relationshiptype": "isGuardedBy"
      },
      {
        "id": "50cb1ac9-0b14-4b80-8f33-c885270faabd",
        "sourceentityid": "Device:Frictionless1",
        "destinationentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "ercollectionid": "facdemo",
        "relationshipname": "Middle Door isLocatedIn GooglePlex",
        "relationshiptype": "isLocatedIn"
      },
      {
        "id": "1e20edde-5b84-446f-a4c2-d50c4e03bf4a",
        "sourceentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "destinationentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "ercollectionid": "facdemo",
        "relationshipname": "GooglePlex isManagedBy Sam Kim",
        "relationshiptype": "isManagedBy"
      },
      {
        "id": "7fb5a326-8ff1-4e70-9662-7f5a2fb8b573",
        "sourceentityid": "86b5239a-8124-4cfe-a0cb-f3e63f9fb8bf",
        "destinationentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "ercollectionid": "facdemo",
        "relationshipname": "Yahoo! isManagedBy Vish Ramamurti",
        "relationshiptype": "isManagedBy"
      },
      {
        "id": "281df0c4-25a3-4170-aa3f-67253128d753",
        "sourceentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "destinationentityid": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "ercollectionid": "facdemo",
        "relationshipname": "Sam Kim managesBuilding GooglePlex",
        "relationshiptype": "managesBuilding"
      },
      {
        "id": "335960df-8c56-4e33-a903-90f8a66fce12",
        "sourceentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "destinationentityid": "86b5239a-8124-4cfe-a0cb-f3e63f9fb8bf",
        "ercollectionid": "facdemo",
        "relationshipname": "Vish Ramamurti managesBuilding Yahoo!",
        "relationshiptype": "managesBuilding"
      },
      {
        "id": "591afa11-b910-4483-92b7-41e59832d0e4",
        "sourceentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "destinationentityid": "c84481a6-4b90-4323-90d8-7b3eeba1eb6c",
        "ercollectionid": "facdemo",
        "relationshipname": "Sam Kim managesCardHolder Jasmine Farias",
        "relationshiptype": "managesCardHolder"
      },
      {
        "id": "d83adbe1-71df-4c95-bf68-e2381cf923b9",
        "sourceentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "destinationentityid": "b6637001-0e91-4a57-96d5-3a95754eca81",
        "ercollectionid": "facdemo",
        "relationshipname": "Sam Kim managesCardHolder Bertina Dorney",
        "relationshiptype": "managesCardHolder"
      },
      {
        "id": "ea9b521e-f4a2-4f4d-b636-629f0815fc8b",
        "sourceentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "destinationentityid": "40ad2974-6f08-456c-afcf-ec8b40469f43",
        "ercollectionid": "facdemo",
        "relationshipname": "Vish Ramamurti managesCardHolder Kris Peggs",
        "relationshiptype": "managesCardHolder"
      },
      {
        "id": "b384cd37-2337-48a9-9ef5-d87db21acc23",
        "sourceentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "destinationentityid": "434878cf-99b6-450e-b771-4c90f6827ddc",
        "ercollectionid": "facdemo",
        "relationshipname": "Vish Ramamurti managesCardHolder Carla Bertoni",
        "relationshiptype": "managesCardHolder"
      },
      {
        "id": "eb53cd5a-3e4e-4f8c-9468-b4abc948414c",
        "sourceentityid": "c84481a6-4b90-4323-90d8-7b3eeba1eb6c",
        "destinationentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "ercollectionid": "facdemo",
        "relationshipname": "Jasmine Farias reportsTo Sam Kim",
        "relationshiptype": "reportsTo"
      },
      {
        "id": "33ce7c1e-01a0-4143-a3dc-99d02d96fc62",
        "sourceentityid": "b6637001-0e91-4a57-96d5-3a95754eca81",
        "destinationentityid": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "ercollectionid": "facdemo",
        "relationshipname": "Bertina Dorney reportsTo Sam Kim",
        "relationshiptype": "reportsTo"
      },
      {
        "id": "1f8fc527-d411-4d2c-9c7f-5ce68272bfee",
        "sourceentityid": "40ad2974-6f08-456c-afcf-ec8b40469f43",
        "destinationentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "ercollectionid": "facdemo",
        "relationshipname": "Kris Peggs reportsTo Vish Ramamurti",
        "relationshiptype": "reportsTo"
      },
      {
        "id": "45eabb6e-7eb5-496d-804a-7ae18eb5302f",
        "sourceentityid": "434878cf-99b6-450e-b771-4c90f6827ddc",
        "destinationentityid": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "ercollectionid": "facdemo",
        "relationshipname": "Carla Bertoni reportsTo Vish Ramamurti",
        "relationshiptype": "reportsTo"
      }
    ]

    return relationshipTypes;

  }

  getRelationshipsByEntityId(id): Array<any> {

    var entityRelationships: any = {};

    let relationships = this.getAllEntityRelationshipsTestData().filter(d => d.sourceentityid == id);
    console.log('Selected Entity Relationships :' + relationships);
    return relationships;
  }

  postTestEntityINstances(entity) {
    this.entityInstances.push(entity);
  }

  getEntityInstancesTestData(): Array<any> {
    var entityInstances: any = {};
    entityInstances = [
      {
        "id": "edce9b1a-1dce-49bd-b7f4-9e112eaa91d5",
        "entitytype": "facdemo:accessevent",
        "ercollectionid": "facdemo",
        "eventCategory": "",
        "eventType": "AccessGranted",
        "credential_id": "",
        "access_status": ""
      },
      {
        "id": "6921e75a-a7ec-4f9d-bfe3-acaf2dbd3540",
        "entitytype": "facdemo:accessevent",
        "ercollectionid": "facdemo",
        "eventCategory": "",
        "eventType": "HeartBeat",
        "credential_id": "",
        "access_status": ""
      },

      {
        "id": "f5d74bda-0900-4980-8ba9-dbb1a4479de4",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "GooglePlex",
        "type": "Building-Headquarters",
        "lat": 47.675716,
        "long": -122.117219,
        "image_uri": "https://cdn.geekwire.com/wp-content/uploads/2016/08/IMG_3819-1240x826.jpg"
      },
      {
        "id": "86b5239a-8124-4cfe-a0cb-f3e63f9fb8bf",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "Yahoo!",
        "type": "Building-Headquarters",
        "lat": 32.7384,
        "long": -121.8863,
        "image_uri": "https://imageserver-bisnow1.netdna-ssl.com/KNrKcnpf8vCbbvBMikR_j9rUcyk=/0x0/publisher/58f660caed0b8_Yahoo_bldg_C.jpeg"
      },
      {
        "id": "ad4db727-014b-4835-b38b-74db1d8e48ee",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "Googleplex - 40",
        "type": "Building-Dev2",
        "lat": 47.654229,
        "long": -122.117219,
        "image_uri": "http://photos.wikimapia.org/p/00/00/10/16/24_big.jpg"
      },
      {
        "id": "665cf3e3-6dcd-464c-9b9f-c1930980ff19",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "Googleplex - 41",
        "type": "Building-Dev1",
        "lat": 47.621741,
        "long": -122.117219,
        "image_uri": "https://foursquare.com/v/googleplex--41/49e8d060f964a5208d651fe3?openPhotoId=52fa8403498e0bb38799ab55"
      },
      {
        "id": "78b8d87d-0b0e-4b23-bec9-a50663fc6f77",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "Yahoo! - Building D",
        "type": "Building-Dev1",
        "lat": 34.3351,
        "long": -121.8863,
        "image_uri": "https://foursquare.com/v/yahoo--building-d/4a70f1f8f964a520d7d81fe3?openPhotoId=599f33b104d1ae28af5a0078"
      },
      {
        "id": "f1874f14-b6d3-4475-a0c0-291f1c899d85",
        "entitytype": "facdemo:building",
        "ercollectionid": "facdemo",
        "name": "Yahoo! - Building E",
        "type": "Building-Dev2",
        "lat": 36.3872,
        "long": -121.8863,
        "image_uri": "https://foursquare.com/v/yahoo--building-e/4a3ac648f964a5203aa01fe3?openPhotoId=590a2ea351950e3a726750d0"
      },

      {
        "id": "c84481a6-4b90-4323-90d8-7b3eeba1eb6c",
        "name": "Jasmine Farias",
        "entitytype": "facdemo:cardholder",
        "ercollectionid": "facdemo",
        "cardNumber": 205033,
        "firstName": "Jasmine",
        "lastName": "Farias",
        "department": "Engineering",
        "position": "Quality Assurance Engineer",
        "company": "Google",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Jasmine.Farias@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },
      {
        "id": "b6637001-0e91-4a57-96d5-3a95754eca81",
        "name": "Bertina Dorney",
        "entitytype": "facdemo:cardholder",
        "ercollectionid": "facdemo",
        "cardNumber": 205034,
        "firstName": "Bertina",
        "lastName": "Dorney",
        "department": "Engineering",
        "position": "Software Engineer",
        "company": "Google",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Bertina.Dorney@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },
      {
        "id": "40ad2974-6f08-456c-afcf-ec8b40469f43",
        "name": "Kris Peggs",
        "entitytype": "facdemo:cardholder",
        "ercollectionid": "facdemo",
        "cardNumber": 205035,
        "firstName": "Kris",
        "lastName": "Peggs",
        "department": "Engineering",
        "position": "Quality Assurance Engineer",
        "company": "Yahoo",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Kris.Peggs@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },
      {
        "id": "434878cf-99b6-450e-b771-4c90f6827ddc",
        "name": "Carla Bertoni",
        "entitytype": "facdemo:cardholder",
        "ercollectionid": "facdemo",
        "cardNumber": 205036,
        "firstName": "Carla",
        "lastName": "Bertoni",
        "department": "Engineering",
        "position": "Software Engineer",
        "company": "Yahoo",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Carla.Bertoni@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },

      {
        "id": "doorDevice1",
        "name": "Bosch 011N",
        "entitytype": "facdemo:device",
        "ercollectionid": "facdemo",
        "devicetype": "Camera-Stationary",
        "devicetypedesc": "Camera Reception 101",
        "deviceparentpanel": "NVR1",
        "devicemodelnumber": "devicemodel1",
        "deviceserielnumber": "deviceseriel1",
        "softwareupgradetime": "",
        "installationtime": "2018-02-01T14:25:35.948125Z",
        "lastservicetime": "",
        "devicehealthupdatetime": "",
        "devicehealthid": "0",
        "devicehealthstring ": "Disconnected"
      },
      {
        "id": "doorDevice2",
        "name": "Cisco PMZ",
        "entitytype": "facdemo:device",
        "ercollectionid": "facdemo",
        "devicetype": "Camera-PTZ",
        "devicetypedesc": "Camera Server Room 101",
        "deviceparentpanel": "NVR2",
        "devicemodelnumber": "devicemodel2",
        "deviceserielnumber": "deviceseriel2",
        "softwareupgradetime": "",
        "installationtime": "2018-02-01T14:25:35.948125Z",
        "lastservicetime": "",
        "devicehealthupdatetime": "",
        "devicehealthid": "0",
        "devicehealthstring ": "Disconnected"
      },
      {
        "id": "doorDevice20",
        "name": "Door 45B",
        "entitytype": "facdemo:device",
        "ercollectionid": "facdemo",
        "devicetype": "door",
        "devicetypedesc": "Door for Server Room 101",
        "deviceparentpanel": "Panel3",
        "devicemodelnumber": "devicemodel22",
        "deviceserielnumber": "deviceseriel22",
        "softwareupgradetime": "",
        "installationtime": "2018-02-01T14:25:35.948125Z",
        "lastservicetime": "",
        "devicehealthupdatetime": "",
        "devicehealthid": "0",
        "devicehealthstring ": "Disconnected"
      },
      {
        "id": "Device:Frictionless1",
        "name": "Middle Door",
        "entitytype": "facdemo:device",
        "ercollectionid": "facdemo",
        "devicetype": "door",
        "devicetypedesc": "",
        "deviceparentpanel": "Panel1",
        "devicemodelnumber": "devicemodel23",
        "deviceserielnumber": "deviceseriel23",
        "softwareupgradetime": "",
        "installationtime": "2018-02-01T14:25:35.948125Z",
        "lastservicetime": "",
        "devicehealthupdatetime": "",
        "devicehealthid": "1",
        "devicehealthstring ": "Connected"
      },

      {
        "id": "c9fa2f09-ac48-4271-b882-ec2c67fc113c",
        "name": "Sam Kim",
        "entitytype": "facdemo:manager",
        "ercollectionid": "facdemo",
        "firstName": "Sam",
        "lastName": "Kim",
        "department": "Engineering",
        "position": "Software Development Manager",
        "company": "Google",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Sam.Kim@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },
      {
        "id": "a1f7f1d5-55a2-463b-9380-6ef400b3a424",
        "name": "Vish Ramamurti",
        "entitytype": "facdemo:manager",
        "ercollectionid": "facdemo",
        "firstName": "Vish",
        "lastName": "Ramamurti",
        "department": "Engineering",
        "position": "Software Development Manager",
        "company": "Google",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Vish.Ramamurti@example.com",
        "isActive": true,
        "sourceType": "Active Directory"
      },

      {
        "id": "9149d363-2cf0-4906-846d-be8bc4393178",
        "name": "Todd Horan",
        "entitytype": "facdemo:security",
        "ercollectionid": "facdemo",
        "firstName": "Todd",
        "lastName": "Horan",
        "department": "Building Security Services",
        "position": "Security Manager",
        "company": "SLS Security Management",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "personalemailid": "Todd.Horan@example.com",
        "isActive": true,
        "sourceType": "Lenel"
      },
      {
        "id": "138a286f-2904-4911-a25b-06d840e86191",
        "name": "Mary Smith",
        "entitytype": "facdemo:security",
        "ercollectionid": "facdemo",
        "firstName": "Mary",
        "lastName": "Smith",
        "department": "Building Security Services",
        "position": "Security Officer",
        "company": "SLS Security Management",
        "countrycode": "1",
        "areacode": "275",
        "personalPhoneNumber": "9233007",
        "workPhoneNumber": "(988)-682-8758",
        "workemailid": "Mary.Smith@example.com",
        "personalemailid": "Mary.Smith@example.com",
        "isActive": true,
        "sourceType": "Lenel"
      }
    ];
    return entityInstances;
  }

  getEntityInstancesByEntityType(etype): any {
    var entities = this.getEntityInstancesTestData();
    var ent = entities.filter(d => d.entitytype == etype);
    return ent;
  }

  getEntityInstancesById(id): any {


    var entities = this.getEntityInstancesTestData();
    var ent = entities.filter(d => d.id == id);
    return ent;
  }

  getRelationshipTypesTestData(): any {

    var relationshipTypes: any = {};
    relationshipTypes = [
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:contains",
        "description": "Schema for Relation facdemo:contains",
        "type": "object",
        "schemaType": "facdemo:contains",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:controls",
        "description": "Schema for Relation facdemo:controls",
        "type": "object",
        "schemaType": "facdemo:controls",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:guards",
        "description": "Schema for Relation facdemo:guards",
        "type": "object",
        "schemaType": "facdemo:guards",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:hasPart",
        "description": "Schema for Relation facdemo:hasPart",
        "type": "object",
        "schemaType": "facdemo:hasPart",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:hasPoint",
        "description": "Schema for Relation facdemo:hasPoint",
        "type": "object",
        "schemaType": "facdemo:hasPoint",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isControlledBy",
        "description": "Schema for Relation facdemo:isControlledBy",
        "type": "object",
        "schemaType": "facdemo:isControlledBy",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isGuardedBy",
        "description": "Schema for Relation facdemo:isGuardedBy",
        "type": "object",
        "schemaType": "facdemo:isGuardedBy",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isLocatedIn",
        "description": "Schema for Relation facdemo:isLocatedIn",
        "type": "object",
        "schemaType": "facdemo:isLocatedIn",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isManagedBy",
        "description": "Schema for Relation facdemo:isManagedBy",
        "type": "object",
        "schemaType": "facdemo:isManagedBy",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isPartOf",
        "description": "Schema for Relation facdemo:isPartOf",
        "type": "object",
        "schemaType": "facdemo:isPartOf",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:isPointOf",
        "description": "Schema for Relation facdemo:isPointOf",
        "type": "object",
        "schemaType": "facdemo:isPointOf",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:managesBuilding",
        "description": "Schema for Relation facdemo:managesBuilding",
        "type": "object",
        "schemaType": "facdemo:managesBuilding",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:managesCardHolder",
        "description": "Schema for Relation facdemo:managesCardHolder",
        "type": "object",
        "schemaType": "facdemo:managesCardHolder",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      },
      {
        "$schema": "http://json-schema.org/draft-06/schema#",
        "title": "facdemo:reportsTo",
        "description": "Schema for Relation facdemo:reportsTo",
        "type": "object",
        "schemaType": "facdemo:reportsTo",
        "ercollectionid": "facdemo",
        "properties": {
          "id": {
            "description": "The unique identifier for the relation",
            "type": "string"
          },
          "sourceEntityId": {
            "description": "source entity id",
            "type": "string"
          },
          "destinationEntityId": {
            "description": "destination entity id",
            "type": "string"
          },
          "relationshipName": {
            "description": "relationship name",
            "type": "string"
          }
        },
        "required": [
          "id",
          "sourceEntityId",
          "destinationEntityId",
          "relationshipName"
        ]
      }
    ]

    return relationshipTypes;
  }

}
